jQuery(document).ready(function(){
  const urlParams = new URLSearchParams(window.location.search);
  const serial_code = urlParams.get('code');
  const pid_value = urlParams.get('pid');
  var manually_input = false;
  jQuery("input[name='serialNumber']").val(serial_code);
  jQuery("input[name='productId']").val(pid_value);
  var ref = document.referrer;
  if(localStorage.getItem("referrer") == null || localStorage.getItem("referrer") == '') {
    ref = document.referrer;
    localStorage.setItem("referrer", ref);
  }
  // alert(ref);
  console.log("Referrer: ", ref);
  console.log("Code: ", serial_code);
  console.log("PID: ", pid_value);
  setTimeout(function(){
    if(serial_code != null && serial_code != "") {
      jQuery(".search__button.verification__button").trigger("click");
    }
  }, 1000);
  
  // alert("Referrer: " + ref);

  function handleVerificationSubmit() {
    var serial_code_input = jQuery("input[name='serialNumber']").val();
    if((manually_input == true && (serial_code_input != "" && pid_value != null)) || (ref == "" && (serial_code_input == null && pid_value != null) || (serial_code_input == null && pid_value == null)) || ((serial_code_input != null && pid_value != null) && (ref== "https://verify.jpattonondemand.com/" || localStorage.getItem("referrer") == "https://verify.jpattonondemand.com/" || localStorage.getItem("referrer").indexOf("https://puffignite.co/") >= 0 || localStorage.getItem("referrer").indexOf("https://chkreal.com/") >= 0))) {
      jQuery(".form_message .success").text("");
      // jQuery(".form_message .error").text("");
      jQuery(".verification__button").addClass("loading");
      jQuery(".verification__button").attr("disabled", "disabled");
      
      let serial = jQuery("input[name='serialNumber']").val();
      let pid = jQuery("input[name='productId']").val();
      if((serial != "" && pid != "" && serial != null && pid != null)) {
        jQuery.ajax({
          type: "GET",
          url: "https://ext.jpattonondemand.com/VerifyProduct?code="+serial+"&pid="+pid,
          dataType: 'json',
          headers: {
            "Authorization": "Basic " + btoa("jpatton:3450"),
            "CH-JP": "JPTT"
          },
          success: function (response){
            console.log(response.hologramauthentication);
            if(response.hologramauthentication == "Success") {
              if(!jQuery(".form_message .error").hasClass("d-none")) {
                jQuery(".form_message .error").addClass("d-none");
              }
              jQuery(".form_message .success").text("Congratulations, your product has been verified as genuine!");
              jQuery(".verification__button").removeAttr("disabled");
            } else {
              jQuery(".cognito_wrapper").removeClass("d-none");
              jQuery(".form_message .error").text("Product is counterfeit!").removeClass("d-none");
            }

            jQuery(".verification__button").removeClass("loading");
            
          }
    
        });
      } else {
        if(serial == "") {
          jQuery(".form_message .error").text("Serial number is required for verification.").removeClass("d-none");;
        } else {
          jQuery(".form_message .error").text("Product ID is required for verification.").removeClass("d-none");;
        }
        
        jQuery(".verification__button").removeAttr("disabled");
        jQuery(".verification__button").removeClass("loading");
      }

    } else {
      jQuery(".cognito_wrapper").removeClass("d-none");
      jQuery(".form_message .error").text("Product is counterfeit!");
      jQuery(".form_message .error").removeClass("d-none");
    }
  }

  
  jQuery(".search.search__form.verification__form").off("submit").on("submit", function(e) {
    e.preventDefault();
  });
  
  jQuery(document).on("click", ".verification__button", function(e){ 
    handleVerificationSubmit();
  });

  jQuery(document).on("keyup", "input[name='serialNumber']", function(e) {
    if(e.keyCode == 13) {
      e.preventDefault();
      manually_input = true;
      handleVerificationSubmit();
    }
    manually_input = true;
    console.log("Manually Input");
  });

  jQuery(".scan_qr_link").on("click", function(){
    jQuery("#reader").toggleClass("d-none");
  });

  // V50, V80 & V150 product page slider
  jQuery('.product_list_item').not('.slick-initialized').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    centerMode: true,
    asNavFor: '.slider-nav',
    prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://puffignite.co/cdn/shop/files/slider-arrow.png'></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://puffignite.co/cdn/shop/files/slider-arrow.png'></button>",
    responsive: [
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 799,
        settings: {
          slidesToShow: 1,
          centerMode: false,
          arrows: false,
          fade: true,
        }
      },
      {
        breakpoint: 481,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  jQuery('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    centerMode: true,
    dots: false,
    arrows: true,
    infinite: true,
    focusOnSelect: true,
    asNavFor: '.product_list_item',
    prevArrow: "<button type='button' class='slick-prev slick-arrow'><img src='https://puffignite.co/cdn/shop/files/slider-arrow.png'></button>",
    nextArrow: "<button type='button' class='slick-next slick-arrow'><img src='https://puffignite.co/cdn/shop/files/slider-arrow.png'></button>",
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
  });

  // V50, V80 & V150 product title & price mobile move
  var productBlock = function() {
    var productClasses = ['.product-v50', '.product-v80', '.product-v150'];
    var productDetailsSelectors = productClasses.map(function(cls) {
      return cls + ' .product__details';
    }).join(', ');
    var productImagesSelectors = productClasses.map(function(cls) {
      return cls + ' .product__images';
    }).join(', ');

    var productDetails = jQuery(productDetailsSelectors);
    var productImages = jQuery(productImagesSelectors);

    if (jQuery(window).width() <= 798) {
      productDetails.each(function() {
        var $detail = jQuery(this);
        if ($detail.find('.product-block--price').length > 0) {
          $detail.closest('.product-v50, .product-v80, .product-v150').find('.product__images').prepend($detail.find('.product-block--price'));
        }
        if ($detail.find('.product-block--title').length > 0) {
          $detail.closest('.product-v50, .product-v80, .product-v150').find('.product__images').prepend($detail.find('.product-block--title'));
        }
      });
    } else {
      productImages.each(function() {
        var $image = jQuery(this);
        if ($image.find('.product-block--price').length > 0) {
          $image.closest('.product-v50, .product-v80, .product-v150').find('.product__details').prepend($image.find('.product-block--price'));
        }
        if ($image.find('.product-block--title').length > 0) {
          $image.closest('.product-v50, .product-v80, .product-v150').find('.product__details').prepend($image.find('.product-block--title'));
        }
      });
    }
  };
  productBlock();
  jQuery(window).on("resize", function() {
    productBlock();
  });

  // scroll to top functions in new product templates 

  $(".scrollToadd").click(function(){
  	var variant = $(".variant-info-wrapper .variant-info.slick-center h3").text().toLowerCase();
  	
  	$("select.single-option-selector option").filter(function() {
  	    return $(this).val().toLowerCase() == variant;
  	}).prop('selected', true);
  	$("select.single-option-selector").trigger('change');
  	$('html, body').animate({
          scrollTop: $("#buyingForm").offset().top
      }, 10);
  });

  // Review section animated scroll
  $(".reviews-tab").click(function(e) {
      e.preventDefault();
      $('html, body').animate({
          scrollTop: $("#judgeme_product_reviews").offset().top - $(".sticky_nav").height()
      }, 300);
  });

  // moving flavor select to up 
  $(document).on("click",".recharge-subscription-widget .rc-radio__input", function() {
    if($(".recharge-subscription-widget .onetime-radio .rc-radio__input:checked").length > 0) {
        $(".recharge-subscription-widget").closest(".product-block").addClass("active");
    } else {
        $(".recharge-subscription-widget").closest(".product-block").removeClass("active");
    }
  });
  
  $(document).on("click",".product-block--form .rc-container-wrapper .rc-radio__input", function() {
      if($(".product-block--form .rc-container-wrapper .rc-option__onetime .rc-radio__input:checked").length > 0) {
          $(".product-block--form .rc-container-wrapper").closest(".shopify-product-form").addClass("active");
      } else {
          $(".product-block--form .rc-container-wrapper").closest(".shopify-product-form").removeClass("active");
      }
  });
});